"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselPlayingOverlayStyles = void 0;
exports.carouselPlayingOverlayStyles = {
    root: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "inherit",
        width: "100%",
        border: "solid 3px #E5B711",
    },
};
//# sourceMappingURL=styles.js.map